import { apiCall, apiCallAdmin } from "../../../services/api-service.js";

export const getfielsApi = async (value) => {
  const response = await apiCall("GET", value ? `register_page${value}` : "register_page");
  return response.data;
};

export const registerSubmitApi = async (data) => {
  const response = await apiCall("POST", "field_config", data);
  return response.data;
};

export const getGateListApi = async (term) => {
  const response = await apiCall("GET", `dockmaster/autosuggestion?term=${term || ""}`);
  return response;
};

export const getDeptListApi = async (term) => {
  const response = await apiCallAdmin("GET", `get_department?term=${term || ""}`);
  return response;
};

export const getFieldListApi = async (term) => {
  const response = await apiCall("GET", `get_fields?term=${term || ""}`);
  return response;
};

export const getListApi = async (term) => {
  const response = await apiCall("GET", term ? `field_config${term}` : "field_config");
  return response;
};

export const getOptionsListApi = async (term) => {
  const response = await apiCall("GET", term ? `register_page/get_fields/${term}` : "register_page/get_fields");
  return response;
};

// Edit
export const getEditApi = async (id) => {
  const response = await apiCall("GET", `field_config/${id}`);
  return response.data;
};

// Update
export const UpdateFieldsApi = async (data, id) => {
  const response = await apiCall("PUT", `field_config/${id}`, data);
  return response;
};

export const getDeleteFieldsApi = async (id) => {
  const response = await apiCall("DELETE", `field_config/${id}`);
  return response;
};

